import { render } from "./SearchIcon.vue?vue&type=template&id=f4b559c0"
import script from "./SearchIcon.vue?vue&type=script&lang=js"
export * from "./SearchIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/Icons/SearchIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4b559c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4b559c0', __exports__)) {
    api.reload('f4b559c0', __exports__)
  }
  
  module.hot.accept("./SearchIcon.vue?vue&type=template&id=f4b559c0", () => {
    api.rerender('f4b559c0', render)
  })

}


export default __exports__